/**
 * Copied intent from escribonauta-projects/services/project-analysis/engine
 * (normalize.ts). That repo was not reachable from this environment
 * (clone returned 404), so this is an equivalent front-only helper:
 * lowercase + strip combining marks (tildes), keeping ñ.
 */

const NORMALIZE_CACHE_LIMIT = 20000
const normalizeCache = new Map<string, string>()

export function normalizeWritingWord(word: string): string {
  const cached = normalizeCache.get(word)
  if (cached !== undefined) return cached
  const normalized = word
    .normalize('NFD')
    .replace(/n\u0303/gi, 'ñ')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
  if (normalizeCache.size >= NORMALIZE_CACHE_LIMIT) {
    normalizeCache.clear()
  }
  normalizeCache.set(word, normalized)
  return normalized
}
